import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const MenuStyle = {
  index: css`
    background: ${theme.colors.gray[850]};
    min-width: 1480px;
    padding: 0 190px;

    ${media["4xl"]} {
      padding: 0 90px;
    }
    ${media.xxl} {
      width: 100%;
      padding: unset;
      min-width: unset;
    }
  `,
  content: css`
    margin: 0 auto;
  `,
  listMenu: css`
    display: flex;
    flex-direction: row;
    align-items: center;

    ${media["4xl"]} {
      justify-content: center;
    }
  `,
  itemMenu: (isActive: boolean, isFocus: boolean) => css`
    position: relative;
    a {
      ${media.xxl} {
        font-size: 12px;
      }
      height: 44px;
      padding: 0 10px;
      /* ${media["4xl"]} {
        padding: 0 10px;
      } */
      ${media["3xl"]} {
        padding: 0 8px;
        font-size: 14px;
      }
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      text-decoration: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: ${isActive || isFocus ? "#727587" : "transparent"};

      &:hover {
        background: #727587;
      }

      img {
        width: 25px;
        height: 25px;
        margin-right: 5px;
        object-fit: contain;
      }

      span {
        text-transform: uppercase;
      }
    }
  `,
};
